"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_2 = require("@fluentui/react");
var clsx_1 = __importDefault(require("clsx"));
var timeUtils_1 = require("../../helpers/timeUtils");
var _1 = require(".");
var stepDuration = 100;
exports.LayoutNotification = function (props) {
    var title = props.title, description = props.description, action = props.action, criticality = props.criticality, onDismissed = props.onDismissed, duration = props.duration;
    var _a = react_1.useState(0), progress = _a[0], setProgress = _a[1];
    var _b = react_1.useState(true), isRunning = _b[0], setIsRunning = _b[1];
    var timerEnabled = isRunning && duration && criticality !== _1.LayoutNotificationCriticality.critical;
    timeUtils_1.useInterval(function () {
        if (duration) {
            if (progress < duration) {
                setProgress(progress + stepDuration);
            }
            else if (onDismissed) {
                onDismissed();
            }
        }
    }, timerEnabled ? stepDuration : undefined);
    var onCloseNotification = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (onDismissed) {
                onDismissed();
            }
            return [2 /*return*/];
        });
    }); }, [onDismissed]);
    var notificationClassName = clsx_1.default('layout-notification', "layout-notification-state--" + criticality);
    return (react_1.default.createElement("div", { className: notificationClassName, onMouseEnter: function () { return setIsRunning(false); }, onMouseLeave: function () { return setIsRunning(true); } },
        react_1.default.createElement(react_2.IconButton, { className: "layout-notification-close", iconProps: {
                iconName: 'Cancel'
            }, onClick: onCloseNotification }),
        react_1.default.createElement("h4", { className: "layout-notification-title" }, title),
        description &&
            react_1.default.createElement("div", { className: "layout-notification-description" }, description),
        action && (react_1.default.createElement("div", { className: "layout-notification-action" },
            react_1.default.createElement(react_router_dom_1.NavLink, { className: "layout-notification-action-link", onClick: onCloseNotification, to: action.pathname }, action.title))),
        criticality !== _1.LayoutNotificationCriticality.critical && duration && duration > 0 && (react_1.default.createElement(react_2.ProgressIndicator, { percentComplete: progress / duration }))));
};
//# sourceMappingURL=LayoutNotification.js.map